import React, {useCallback, useState, useRef, useEffect} from 'react'
import * as R from 'ramda';
import {useTranslation} from "react-i18next";
import {GroupBox} from "../../field/groupbox";
import {FlexGrid} from "../../../grid";
import {TextInput} from "../../field/text-inputs";
import {CATEGORY, ReactSelect} from "../../field/react-selects";
import {FiTrash2} from 'react-icons/fi'
import getField from "../get.field";
import {useFieldArray} from "react-hook-form";
import {IconPlus, IconTrash} from "../../../icons";
import {ButtonSecondary} from "../../../button";
import styled from "styled-components";
import {ModalConfirmDelete} from "../../../modals";

const REPEAT_HITS_OPTIONS = [
    {value: 2, label: 'resource_page.adcampaign.field.offer_url_repeat_hit/two_or_more'},
    {value: 3, label: 'resource_page.adcampaign.field.offer_url_repeat_hit/three_or_more'},
    {value: 4, label: 'resource_page.adcampaign.field.offer_url_repeat_hit/four_or_more'},
    {value: 5, label: 'resource_page.adcampaign.field.offer_url_repeat_hit/five_or_more'},
];

const AddOfferBtnCont = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 1rem;
`

const RemoveOfferBlockBtnCont = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: -1rem;
`

const RemoveButtonBox = styled(ButtonSecondary)`
    &[data-absolute-top='true'] {
      z-index: 1;
      position: absolute;
      top: 0;
      right: 0;
      transform: translateY(-50%);

      //TODO: check the media point transition
      @media all and (max-width: 1200px) {
        top: 10px;
        transform: translateY(0);
      }
    }
`

const HorizontalLine = styled.div`
    width: 100%;
    height: 1px;
    margin: -0.5rem 0 1.5rem 0;
    background: var(--it-stroke-grey);
`

export const RemoveOfferBtn = ({
                          descriptionLabel,
                          styles = {},
                          className = '',
                          isAbsoluteTop = false,
                          onRemove
}) => {
  const [deleteModal, updateDeleteModal] = useState({isShow: false, itemId: false});

  const openModalConfirmDelete = () => updateDeleteModal((prevState) => ({ ...prevState, isShow: true}))
  const closeModalConfirmDelete = () => updateDeleteModal((prevState) => ({ ...prevState, isShow: false}))

  const onRemoveBtnClick = (event) => {
    event.preventDefault()
    openModalConfirmDelete()
  }

  const doRemove = (event) => {
    event.preventDefault()
    onRemove && onRemove()
    closeModalConfirmDelete()
  }

  return (
    <>
      <RemoveButtonBox data-transparent
                       data-absolute-top={!!isAbsoluteTop}
                       onClick={onRemoveBtnClick}
                       type={"button"}
                       style={styles}
                       className={`ml-2 ${className}`}
      >
        <IconTrash size={16}/>
      </RemoveButtonBox>

      <ModalConfirmDelete
        isOpen={deleteModal.isShow}
        itemIds={deleteModal.itemId}
        onCancel={closeModalConfirmDelete}
        onConfirm={doRemove}
        description={descriptionLabel}
      />
    </>
  )
}
export const FormOfferUrlBlock = ({
                             isFixed = false,
                             name,
                             offerId,

                             onRemoveBlock,
                             ...rest
                           }) => {
  const { t } = useTranslation();

  const { fields: repeatFields, append, prepend, remove, swap, move, insert } = useFieldArray({
      control: rest.control,
      name: `${rest.fieldProps.name}.${name}.repeat`,
  });

  let color = 'blue';

  return (
      <>
        <GroupBox
          className={'relative w-full'}
          flex={{direction: 'col', space: '-'}}
          label={t(`resource_page.adcampaign.field.${name === 'default' ? 'offer_default' : 'offer_for_country'}`, {geo: name.toUpperCase()})}
          /*labelBold={true}*/
          inlineExtended={true}
          classNameContent={'w-full xl:flex-1'}
        >
          {!isFixed &&
            <>
              <RemoveOfferBtn
                isAbsoluteTop={true}
                descriptionLabel={t('modal.confirmdelete.description_offer_other_geo')}
                onRemove={() => onRemoveBlock(offerId, name)}
              />
            </>
          }

          <div className={"w-full"}>
            {name !== 'default' && getField({...rest}, rest.formErrors, rest.formInitialValues,
              {
                className: 'ml-2',
                label: t(`resource_page.adcampaign.field.offer_geo`),
                error: {required: t('form.error.required', {name: t('resource_page.adcampaign.field.offer_geo')})},
                name: `${rest.fieldProps.name}.${name}.geo`,
                type: 'reactselect',
                isClearable: true,
                isMulti: true,
                isSearchable: true,
                loadOptions: 'countries',
              },
              0)
            }
            {getField({...rest}, rest.formErrors, rest.formInitialValues,
              {
                className: 'ml-2',
                label: t(`resource_page.adcampaign.field.offer_url`),
                error: {required: t('form.error.required', {name: t('resource_page.adcampaign.field.offer_url')})},
                name: `${rest.fieldProps.name}.${name}.url`,
                type: 'url',
                pattern: "https://.*",
              },
              1)
            }
          </div>

          {repeatFields.length > 0 && repeatFields.map((item, idx) => (
            <FlexGrid key={`repeat.${item.id}`} className={"w-full ml-2"} columns={[{
              className: `pr-2 w-48`,
              content: getField({...rest}, rest.formErrors, rest.formInitialValues,
                {
                  error: {required: true},
                  name: `${rest.fieldProps.name}.${name}.repeat.${idx}.key`,
                  type: 'reactselect',
                  isClearable: false,
                  options: REPEAT_HITS_OPTIONS,
                },
                0),
            }, {
              flex: 'auto',
              className: ``,
              content: getField({...rest}, rest.formErrors, rest.formInitialValues,
                {
                  error: {required: true},
                  name: `${rest.fieldProps.name}.${name}.repeat.${idx}.value`,
                  type: 'url',
                  pattern: "https://.*",
                },
                1),
            }, {
              className: `flex items-start`,
              content: <>
                <RemoveOfferBtn
                  descriptionLabel={t('modal.confirmdelete.description_offer_repeat_app')}
                  onRemove={() => remove(idx)}
                />
              </>,
            },
            ]}/>)
          )}

          {(!repeatFields || repeatFields.length < 5) &&
            (
              <>
                <AddOfferBtnCont>
                  <ButtonSecondary onClick={() => append({ key: "", value: "" })}
                                   type={"button"}
                  >
                    <IconPlus size={20}/>
                    {t(`resource_page.adcampaign.field.offer_add_btn_for_repeat_app`)}
                  </ButtonSecondary>
                </AddOfferBtnCont>
              </>
            )}
        </GroupBox>
        {/*render_horizontal_line*/}
        <>
          <HorizontalLine />
        </>
      </>
  )
}
